module.exports = __webpack_public_path__ + "img/add_page.cffbc6d5.svg";